<details-section [showDetails]="false" *ngIf="isTranslationLoaded">
  <ng-container slot="header">
    <div class="sessions-header">
      <div class="sessions-info">
        <h2 class="sessions-title">{{ 'reportingV2.SESSIONS' | transloco }}</h2>
        <span class="sessions-count">{{ tableData.length }} {{ 'reportingV2.TOTAL' | transloco }}</span>
      </div>

      <qai-searchable-select [shape]="'rectangle'" [placeholder]="'reportingV2.ASSIGNMENT_NAME' | transloco"
      [options]="assignmentOptions" [searchable]="true" [searchPlaceholder]="'reportingV2.SEARCH_ASSIGNMENTS' | transloco"
      [multiselect]="true" [value]="selectedAssignments" (valueChange)="onAssignmentFilterChange($event)"
      [scopedOptionsSelectionMode]="scopedOptionsSelectionModeAssignments" [clearButton]="assignmentClearOption"
      [othersTextFormatter]="othersTextFormatter">
      </qai-searchable-select>

      <qai-searchable-select [shape]="'rectangle'" [placeholder]="'reportingV2.SIMULATION_NAME' | transloco"
          [options]="simulationOptions" [searchable]="true"
          [searchPlaceholder]="'reportingV2.SEARCH_SIMULATIONS' | transloco" [value]="selectedSimulations"
          [multiselect]="true" (valueChange)="onSimulationFilterChange($event)"
          [scopedOptionsSelectionMode]="scopedOptionsSelectionModeSimulations" [clearButton]="simulationClearOption"
          [othersTextFormatter]="othersTextFormatter">
      </qai-searchable-select>

      <div class="date-filters">
        <qai-datepicker
          [endIcon]="'chevron-down'"
          [disabled]="false"
          [placeholder]="'reportingV2.START_DATE_LABEL' | transloco"
          [kind]="'default'"
          [shape]="'rectangle'"
          [size]="'medium'"
          [weight]="'regular'"
          [minDate]="minStartDate"
          [maxDate]="maxStartDate"
          [value]="startDate"
          [displayFormatter]="datePickerFormatter"
          (valueChange)="onDateChange('startDate', $event)"
        ></qai-datepicker>

        <qai-datepicker
          [endIcon]="'chevron-down'"
          [disabled]="false"
          [placeholder]="'reportingV2.END_DATE_LABEL' | transloco"
          [kind]="'default'"
          [shape]="'rectangle'"
          [size]="'medium'"
          [weight]="'regular'"
          [minDate]="minEndDate"
          [maxDate]="maxEndDate"
          [value]="endDate"
          [displayFormatter]="datePickerFormatter"
          (valueChange)="onDateChange('endDate', $event)"
        ></qai-datepicker>
      </div>

      <button class="download-btn" (click)="onDownloadClick()">
        <qai-icon [kind]="'download'" [size]="'20px'"></qai-icon>
      </button>
    </div>
  </ng-container>

  <div *ngIf="showScatterPlot" class="scatter-container">
    <div #scatterPlotContainer class="scatter-plot-container"></div>
  </div>
  
  <qai-table
    *ngIf="!isLoading"
    [headers]="headers"
    [data]="tableData"
    [showTimeInDateDisplay]="true"
    [striped]="false"
    [currentPage]="currentPage"
    [showPagination]="true"
    [pageSize]="10"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
    (pageChanged)="onPageChanged($event)"
    (sortChanged)="onSortChanged($event)"
    (rowClick)="onTableRowClick($event)"
    [noDataMessage]="'reportingV2.No_SIMULATION' | transloco"
    [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco"
    [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"
  ></qai-table>
</details-section>